import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';
import {ModalVisibilityService} from '../../../../services/modal-visibility.service';
import {DevicesTableModalComponent} from '../../project_table/devices-table-modal/devices-table-modal.component';
import {SmallTextInfoModalComponent} from '../../../small-text-info-modal/small-text-info-modal.component';
import {ProjectsApprovalListItemModel} from '../../../../models/projects-approval-list-item.model';
import {RPriceIdentifierEnum} from '../../../../enums/r-price-identifier.enum';
import {DateTimeUtils} from '../../../../utils/date-time.utils';
import {ActionsMenuComponent} from '../../tables_shared_components/actions-menu/actions-menu.component';
import {PriceApprovalStatusEnum} from '../../../../enums/price-approval-status.enum';
import {ModalDynamicV3Service} from '../../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-project-price-approval-table-row',
    templateUrl: './project-price-approval-table-row.component.html',
    styleUrls: ['./project-price-approval-table-row.component.scss']
})
export class ProjectPriceApprovalTableRowComponent implements OnInit {

    private closeMenuTimer: any;
    private openPriceInfoModalTimer: any;

    public priceApprovalStatusEnum = PriceApprovalStatusEnum;

    @ViewChild('actionMenu', {static: true}) actionMenu: ActionsMenuComponent;

    @Input() public project: ProjectsApprovalListItemModel;
    // tslint:disable-next-line:max-line-length
    @Input() isProcessedModeUsed = false;  // if the table is used for second tab 'Bearbeitete Projekte / Processed projects', the columns should be changed little bit

    @Output() public projectRowActionsMenuClicked = new EventEmitter<{
        projectListItem: ProjectsApprovalListItemModel,
        actionId: MyProjectsTableRowActionEnum
    }>();

    public isActionsMenuVisible = false;

    // private modalVisibilitySub: Subscription;

    private priceInfoModalDialogRef: any;

    private today: Date;

    public actionMenuItems = [
        {label: 'TCO Kalkulation', faName: 'calculator', actionId: MyProjectsTableRowActionEnum.TCO_CALCULATION},
    ];
    private deviceTabModalDialogRef: IModalDialogV3;
    private openDeviceTabModalTimer: any;


    constructor(
        private modalDynamicV3Service: ModalDynamicV3Service,
        private modalVisibilityService: ModalVisibilityService,
    ) {
    }

    public ngOnInit() {
        this.today = new Date(DateTimeUtils.getTomorrowDate().setMilliseconds(-1));

        // this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {
        //         this.closeActionsMenu();
        //     }
        // );
    }

    public onActionsBtnClicked() {
        if (this.isActionsMenuVisible) {
            this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
        } else {
            this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
            this.isActionsMenuVisible = true;
            this.actionMenu.open();
        }

    }


    public closeActionsMenu() {
        this.isActionsMenuVisible = false;
        this.actionMenu.close();
    }

    public onActionsMenuItemClicked(actionId: MyProjectsTableRowActionEnum) {
        this.isActionsMenuVisible = false;
        this.projectRowActionsMenuClicked.next({projectListItem: this.project, actionId: actionId});
    }


    public setCloseMenuTimer() {
        if (this.isActionsMenuVisible) {
            this.closeMenuTimer = setTimeout(_ => this.closeActionsMenu(), 300);
        }
    }

    public removeCloseMenuTimer() {
        if (this.closeMenuTimer) {
            clearTimeout(this.closeMenuTimer);
        }
    }


    public onStatusInfoMouseEnter(anchor: HTMLElement, project: ProjectsApprovalListItemModel) {
        const messages = [project.priceApprovalComment];
        const title = project.priceApprovalStatus === PriceApprovalStatusEnum[PriceApprovalStatusEnum.PRICES_APPROVED] ? 'Preise freigegeben' : 'Preise abgelehnt';

        this.openPriceInfoModalTimer =
            setTimeout(_ => this.openStatusInfoModal(anchor, title, messages), 300);
    }

    public onStatusInfoMouseLeave() {
        if (this.openPriceInfoModalTimer) {
            clearTimeout(this.openPriceInfoModalTimer);
        }
        if (this.priceInfoModalDialogRef) {
            this.priceInfoModalDialogRef.close();
            this.priceInfoModalDialogRef = undefined;
        }

    }

    public openStatusInfoModal(anchor: HTMLElement, title: string ,messages: string[]) {

        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        const deltaX = -200;
        const deltaY = 29;


        const top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+anchor.getBoundingClientRect().right) + deltaX;

        this.priceInfoModalDialogRef = this.modalDynamicV3Service
            .open(SmallTextInfoModalComponent, {
                model: {
                    title: title,
                    messages: messages,
                    top: top,
                    left: left,
                    showCloseBtn: false,
                    minHeight: 40,
                    closeEvent: this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$
                }
            }, true);


        // this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {
        //
        //     if (this.priceInfoModalDialogRef) {
        //         this.priceInfoModalDialogRef.close();
        //         this.modalVisibilitySub.unsubscribe();
        //         this.priceInfoModalDialogRef = undefined;
        //         this.modalVisibilitySub = undefined;
        //     }
        // });

    }


    public getStatusDetailText(priceApprovalStatusDetail: string): string {
        return PriceApprovalStatusEnum[priceApprovalStatusDetail] === PriceApprovalStatusEnum.PRICES_APPROVED ? 'Freigegeben' : 'Abgelehnt';
    }

    public displayAsBtn(project: ProjectsApprovalListItemModel): boolean {
        return !this.isProcessedModeUsed && RPriceIdentifierEnum [project.maxCondition] >= RPriceIdentifierEnum.R7;
    }

    public displayHighlighted(project: ProjectsApprovalListItemModel): boolean {
        return !this.isProcessedModeUsed && project.quoteClosingDate < this.today;
    }


    public onDeviceAmountMouseEnter(anchor: HTMLElement) {
        if (this.project.requestedProductsTotalCount && this.project.requestedProductsTotalCount > 0) {

            if (this.project.devices.length) {
                this.openDeviceTabModalTimer = setTimeout(_ => this.openDevicesTabModal(anchor), 300);
            } else {
                console.error('project approval devices do not match with requestedProductsTotalCount, ' +
                    'project approval model is not consistent, (hover fnc. was not executed)', this.project);
            }
        }
    }

    public onDeviceAmountMouseLeave() {
        if (this.openDeviceTabModalTimer) {
            clearTimeout(this.openDeviceTabModalTimer);
        }
    }

    public openDevicesTabModal(anchor: HTMLElement) {


        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        const deltaX = -169;
        const deltaY = 20;


        // helps avoid to display dialog out of the screen
        const expectedDialogHeight = 270;
        const marginBottom = 10;


        const top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+anchor.getBoundingClientRect().right) + deltaX;

        this.deviceTabModalDialogRef = this.modalDynamicV3Service
            .open(DevicesTableModalComponent, {
                model: {
                    project: this.project,
                    top: top,
                    left: left,
                    marginBottom: 10,
                    closeEvent: this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$
                }
            }, true);


        // this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {
        //
        //     if (this.deviceTabModalDialogRef) {
        //         this.deviceTabModalDialogRef.close();
        //         this.modalVisibilitySub.unsubscribe();
        //         this.deviceTabModalDialogRef = undefined;
        //         this.modalVisibilitySub = undefined;
        //     }
        // });

    }

    // public ngOnDestroy(): void {
    //     if (this.modalVisibilitySub) {
    //         this.modalVisibilitySub.unsubscribe();
    //     }
    // }

    public getMaxConditionBtnLabel(maxCondition: string): string {
      if ( RPriceIdentifierEnum [maxCondition] === RPriceIdentifierEnum.CUSTOM){
          return "Anderer Preis";
      }
      return maxCondition;
    }
}
